import { useMediaQuery } from '@mui/material';
import { theme } from '../styles/theme';

// mobile layout: window narrower than md (900px), live on resize/rotation, regardless of touch
export const useIsMobileLayout = (): boolean => {
	return useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
};
